import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { localize } from 'react-localize-redux';

import { TextField, SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';

import * as validator from 'helpers/Validator';
import { getSuiteRooms } from 'helpers/SelectOptions';
import PropertyUnitSelector from 'components/shared/PropertyUnitSelector';
import { getProperties, getUnits } from 'actions/landlordPropertiesActions';
import { getMaintenanceCategories, getMaintenanceLocations } from 'actions/maintenanceActions';

const style = {
  property_menu: { minWidth: '250px', fontSize: '14px' },
  property: { textAlign: 'left', fontSize: '14px' },
  field: { marginTop: '-10px', fontSize: '14px' },
  icon: { marginLeft: '20px !important' },
  tenant_note: {
    marginTop: '2px',
    fontSize: '14px',
    marginBottom: '-3px',
  },
};

class RequestMaintenanceKioskForm extends React.Component {
  componentDidMount() {
    this.props.getProperties({ for_multiselect: true });
  }

  getPropertyType = () => {
    const { selectedProperty, properties } = this.props;
    if (!selectedProperty) return null;

    const propertyHash = properties.find((property) => property.value === selectedProperty.value);
    return propertyHash && propertyHash.property_type;
  };

  render() {
    const { handleSubmit, properties, units, changeFieldValue, maintenanceCategories } = this.props;

    const getUnits = (value) => {
      const property_id = value && value.value;
      this.props.getMaintenanceCategories(property_id);
      this.props.getMaintenanceLocations(property_id);
      if (property_id) {
        changeFieldValue('unit_selected', null);
        this.props.getUnits(property_id, { for_multiselect: true });
      }
    };

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <PropertyUnitSelector
            properties={properties}
            units={units}
            onPropertyChange={getUnits}
            propertyInnerDivStyle={{
              width: '100%',
              fontSize: '14px',
              fontWeight: '100 !important',
            }}
            propertyMenuStyle={style.property_menu}
            propertyStyle={style.property}
            unitMenuStyle={{ fontSize: '14px' }}
            unitStyle={style.property}
            allowNone
          />

          <div className="row">
            <div className="col-sm-6">
              <Field
                name="category"
                component={SelectField}
                style={style.field}
                floatingLabelText="Category"
                fullWidth
                validate={[validator.required]}
                iconStyle={style.icon}
              >
                {maintenanceCategories.map((category) => (
                  <MenuItem value={category.value} key={category.label} label={category.label}>
                    {category.label}
                  </MenuItem>
                ))}
              </Field>
            </div>
            <div className="col-sm-6">
              <Field
                name="suite_location"
                component={SelectField}
                style={style.field}
                floatingLabelText="Location"
                fullWidth
                validate={[validator.required]}
                iconStyle={style.icon}
              >
                {getSuiteRooms(this.props.unit_selected, this.getPropertyType()).map((room) => (
                  <MenuItem
                    value={room.value}
                    key={this.props.translate(room.label)}
                    label={this.props.translate(room.label)}
                  >
                    {this.props.translate(room.label)}
                  </MenuItem>
                ))}
              </Field>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <Field
                name="subject"
                validate={[validator.required]}
                component={TextField}
                floatingLabelText="Subject"
                fullWidth
                style={{ marginTop: '-21px', fontSize: '14px' }}
              />
            </div>
            <div className="col-xs-12" style={{ marginTop: '-5px' }}>
              <Field
                name="ticket_description"
                component={TextField}
                validate={[validator.required]}
                floatingLabelText="Description"
                multiLine={true}
                fullWidth
                rows={1}
                style={{ marginTop: '-15px', fontSize: '14px' }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12" style={{ marginTop: '-5px' }}>
              <Field
                name="tenant_note"
                component={TextField}
                hintText="These notes will be visible by your landlord."
                hintStyle={{ fontSize: '14px' }}
                rows={2}
                multiLine={true}
                fullWidth
                floatingLabelText="Additional Notes"
                style={style.tenant_note}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

RequestMaintenanceKioskForm = reduxForm({
  form: 'new_kiosk_ticket_form',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(RequestMaintenanceKioskForm);

RequestMaintenanceKioskForm = connect(
  (store) => ({
    properties: store.landlordProperties.properties,
    units: store.landlordProperties.units,
    unit_selected: formValueSelector('new_kiosk_ticket_form')(store, 'unit_selected'),
    selectedProperty: formValueSelector('new_kiosk_ticket_form')(store, 'property'),
    maintenanceCategories: store.maintenanceReducer.maintenanceCategories,
  }),
  { getProperties, getUnits, getMaintenanceCategories, getMaintenanceLocations }
)(RequestMaintenanceKioskForm);

export default localize()(RequestMaintenanceKioskForm);
